"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'StoreMenuDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 已选择的门店ID列表
    selectedStoreIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 区域门店列表
    regionStoreList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 提交时的验证函数，返回Promise
    validateFunc: {
      type: Function,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formData: {
        storeScope: 1,
        relatedStoreIdList: []
      },
      submitLoading: false
    };
  },
  watch: {
    visible: function visible(newVal) {
      if (newVal) {
        this.initFormData();
      }
    }
  },
  methods: {
    initFormData: function initFormData() {
      this.formData.relatedStoreIdList = (0, _toConsumableArray2.default)(this.selectedStoreIds);
      this.checkIfAllStoreSelected(this.formData.relatedStoreIdList);
    },
    // 检查区域是否完全选中
    isRegionFullyChecked: function isRegionFullyChecked(regionStore) {
      var selectedStores = this.formData.relatedStoreIdList || [];
      var regionStoreIds = regionStore.storeList.map(function (store) {
        return store.storeId;
      });
      return regionStoreIds.length > 0 && regionStoreIds.every(function (id) {
        return selectedStores.includes(id);
      });
    },
    // 检查区域是否为半选状态
    isRegionIndeterminate: function isRegionIndeterminate(regionStore) {
      var selectedStores = this.formData.relatedStoreIdList || [];
      var regionStoreIds = regionStore.storeList.map(function (store) {
        return store.storeId;
      });
      var selectedCount = selectedStores.filter(function (id) {
        return regionStoreIds.includes(id);
      }).length;
      return selectedCount > 0 && selectedCount < regionStore.storeList.length;
    },
    // 处理区域全选/取消全选
    handleRegionCheckAllChange: function handleRegionCheckAllChange(checked, regionStore) {
      var storeIds = regionStore.storeList.map(function (store) {
        return store.storeId;
      });
      var newStoreIds = (0, _toConsumableArray2.default)(this.formData.relatedStoreIdList || []);
      if (checked) {
        // 全选该区域的所有门店
        newStoreIds = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(newStoreIds), (0, _toConsumableArray2.default)(storeIds))));
      } else {
        // 取消选择该区域的所有门店
        newStoreIds = newStoreIds.filter(function (id) {
          return !storeIds.includes(id);
        });
      }
      this.$set(this.formData, 'relatedStoreIdList', newStoreIds);
      this.updateStoreScopeBasedOnSelection(newStoreIds);
    },
    // 处理门店选择变化
    handleStoreCheckChange: function handleStoreCheckChange(value) {
      this.$set(this.formData, 'relatedStoreIdList', value);
      this.updateStoreScopeBasedOnSelection(value);
    },
    // 根据选择的门店更新 storeScope 状态
    updateStoreScopeBasedOnSelection: function updateStoreScopeBasedOnSelection(selectedStoreIds) {
      var allStoreIds = this.regionStoreList.flatMap(function (region) {
        return region.storeList.map(function (store) {
          return store.storeId;
        });
      });

      // 如果选择了所有门店，则设置为全选模式
      if (allStoreIds.length > 0 && allStoreIds.every(function (id) {
        return selectedStoreIds.includes(id);
      })) {
        this.$set(this.formData, 'storeScope', 0);
      } else {
        this.$set(this.formData, 'storeScope', 1);
      }
    },
    // 处理全门店选择变更
    handleStoreScopeChange: function handleStoreScopeChange(val) {
      if (val === 0) {
        // 选择全部门店时，收集所有门店ID
        var allStoreIds = this.regionStoreList.flatMap(function (region) {
          return region.storeList.map(function (store) {
            return store.storeId;
          });
        });
        this.$set(this.formData, 'relatedStoreIdList', allStoreIds);
      }
    },
    // 添加检查是否全选的方法
    checkIfAllStoreSelected: function checkIfAllStoreSelected(storeIds) {
      var allStoreIds = this.regionStoreList.flatMap(function (region) {
        return region.storeList.map(function (store) {
          return store.storeId;
        });
      });
      if (allStoreIds.length > 0 && allStoreIds.every(function (id) {
        return storeIds.includes(id);
      })) {
        this.$set(this.formData, 'storeScope', 0);
      } else {
        this.$set(this.formData, 'storeScope', 1);
      }
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleCancel: function handleCancel() {
      this.handleClose();
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.submitLoading = true;

      // 如果有验证函数，先执行验证
      if (this.validateFunc) {
        this.validateFunc(this.formData.relatedStoreIdList).then(function (message) {
          if (message) {
            _this.$confirm(message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this.doSubmit();
            }).catch(function () {
              _this.submitLoading = false;
            });
          } else {
            _this.doSubmit();
          }
        }).catch(function () {
          _this.submitLoading = false;
        });
      } else {
        this.doSubmit();
      }
    },
    doSubmit: function doSubmit() {
      this.$emit('submit', {
        storeScope: this.formData.storeScope,
        relatedStoreIdList: this.formData.relatedStoreIdList
      });
      this.submitLoading = false;
    }
  }
};